import API from "service";

export async function calculateDailyRiskScoresService(userId) {
  const { data } = await API.post(
    `/secure/daily/risk-scoring/${userId}/calculate`
  );

  return data.data || [];
}